export default __webpack_public_path__ + "static/media/our-story-bg2.52c8ea9f.jpg";